import {useTranslation} from 'react-i18next'
import {type Cifra} from '@/hooks/empresa/organizacion/use-cifras'
import {formatDate} from '@/lib/risk'

/** Nunca se muestra un valor sin ella (docs/modulos/perfil-cargo-spec.md §8). */
export function CifraProcedencia({cifra}: {cifra: Cifra}) {
  const {t} = useTranslation()
  const texto =
    cifra.origen === 'fijada_empresa'
      ? t('cifras.procedencia.empresa', {
          fecha: formatDate(cifra.fijada_en!),
          nombre: cifra.fijada_por_nombre ?? '',
        })
      : t(cifra.origen === 'propuesto_kairos' ? 'cifras.procedencia.kairos' : 'cifras.procedencia.sinDefinir')
  return (
    <p className="text-xs text-muted-foreground" data-testid="cifra-procedencia">
      {texto}
    </p>
  )
}
